var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "newPopover",
    {
      ref: "newPopover",
      attrs: { title: "修改logo" },
      on: {
        dlodingHide: function($event) {
          return _vm.clearData("")
        },
        clearData: function($event) {
          return _vm.clearData(_vm.form.id)
        },
        submitData: _vm.submitData
      }
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "语言", prop: "language" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.language,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "language", $$v)
                        },
                        expression: "form.language"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "中文", value: "zh" }
                      }),
                      _c("el-option", { attrs: { label: "英语", value: "en" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "LOGO", prop: "desc" }
                },
                [
                  _c("uploadImage", {
                    ref: "logoUploadImage",
                    attrs: { limit: 1 },
                    on: {
                      change: function($event) {
                        return _vm.logoUrl($event)
                      },
                      delUrl: function($event) {
                        return _vm.delUrl($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }